// extracted by mini-css-extract-plugin
export var cooperationFlow = "index-module--cooperationFlow--qVFfT";
export var flow = "index-module--flow--BtK2I";
export var flowNumber = "index-module--flowNumber--1BfKB";
export var greyBg = "index-module--greyBg--W-Wfb";
export var hidden = "index-module--hidden--4Yb2M";
export var inner = "index-module--inner--d4lUg";
export var outer = "index-module--outer--eXBuH";